import { ApiSystem, Asset } from "../state/types";

type Direction = "cw" | "ccw";

/** Resolve the camera rotation direction for an asset.
 *
 *  Source of truth (per product): the asset's configuration on its system —
 *  `config.assetProcessing.general.cameraDirection`. Looked up by matching
 *  `asset.systemCode` → system, then `asset.config` → configuration entry.
 *
 *  Falls back to `asset.cameraDirection` for backward compat, and finally
 *  to `"cw"` when nothing is set. */
export function resolveCameraDirection(
  asset: Asset | null | undefined,
  systems: ApiSystem[] | null | undefined,
): Direction {
  if (asset) {
    const system = (systems || []).find((s) => s?.systemCode === asset.systemCode);
    const configs = system?.configurations;
    const config = configs && asset.config ? configs[asset.config] : undefined;
    const fromConfig = config?.assetProcessing?.general?.cameraDirection;
    if (fromConfig === "cw" || fromConfig === "ccw") return fromConfig;

    const fromAsset = asset.cameraDirection;
    if (fromAsset === "cw" || fromAsset === "ccw") return fromAsset;
  }
  return "cw";
}
